import Model from './reminder_settings_model';
import DOM from '../../../../utils/dom';
import Store from '../../../../utils/store';
import BaseOptionsComponentController from '../base_options_component_controller';
import {REMINDER_SETTINGS_SELECTORS} from './reminder_settings_const';
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS, USER_EVENTS} from '../../../../events/events';
import Strings from '../../../../utils/strings';
import _ from '../../../../utils/underscore';
import TimeSpan from '../../../../utils/time_span';

// Views
let options = require('./view/reminder_settings.html');
const REMINDER_STORAGE_KEY = 'reminder';


const ELASTIC_ACTION_NAMES = {
    SAVE: 'Save',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    MOREINFO: 'MoreInfo'
}

class ReminderSettingsController extends BaseOptionsComponentController {

    static CLASS = 'ReminderSettingsController';

    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;

    /**
     *`
     * @param params
     */
    init(params) {
        super.init();
        this._model = Model.create(this._initModel(params));
    }


    /**
     * Default root cgp component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-component-reminder';


    /**
     * Get reminder key for specific user cid
     *
     * @returns {*}
     * @private
     */
    _getReminderKey() {
        let key = null;
        // user service data
        let accountData = this.serviceFactory.userService().getAccountData();
        if (_.isUndefined(accountData) || _.isNull(accountData)) {
            return null;
        }
        key = REMINDER_STORAGE_KEY + '_' + accountData.Cid;

        return key;
    }


    /**
     * initialize model object
     *
     * @private
     * @returns {}
     */
    _initModel() {
        let optionsObj = {};
        let intervals = this._getIntervals();

        if (intervals && 0 < intervals.length) {
            const storedReminderValue = Store.get(this._getReminderKey())
            if(storedReminderValue) {
                const reminderIntervalAsNumber = Number(storedReminderValue);
                if(_.isNumber(reminderIntervalAsNumber)) {
                    optionsObj.reminder = TimeSpan.fromMinutes(reminderIntervalAsNumber);
                } else {
                    optionsObj.reminder = TimeSpan.parse(storedReminderValue);
                }

            } else {
                optionsObj.reminder = TimeSpan.fromMinutes(0);
            }

        }

        return optionsObj;
    }

    /**
     * Start the component view.
     *
     *
     * @returns {ReminderSettingsController}
     * @public
     */
    start() {
        // init the component layouts
        let bakedHTML = this.bake(options);
        this.setHTML(bakedHTML)
            ._bindOptions()
            ._subscribeDOMEvents();

        return this;
    }


    /**
     *
     */
    off() {
        if (Store.del(this._getReminderKey())) {
            this._model.setOptions({reminder: 0});
        }
    }


    /**
     * Get intervals values for regulation
     * @returns {Array}
     * @public
     */
    _getIntervals() {
        let intervals = this.serviceFactory.regulationService().getReminderIntervals();

        return intervals;
    }


    /**
     * Bind array of intervals to selected DDL into the view
     * define selected change events.
     * @returns {*}
     * @private
     */
    _bindOptions() {
        let reminderIntervals = this._getIntervals();
        if (!reminderIntervals || 0 === reminderIntervals.length) {
            return this;
        }

        let ddlReminder = this.getEl().querySelectorAll(REMINDER_SETTINGS_SELECTORS.REMINDER_OPTIONS);

        if (0 < !ddlReminder && ddlReminder) {
            return this;
        }

        let reminderOptions = reminderIntervals.map(optionItem => {
            let el = DOM.createElement('option');
            el.value = optionItem;
            DOM.addClass(el, 'cgp-themes-main-text');
            DOM.addClass(el, 'cgp-theme-property-background-color-base03');

            let languageService = this.serviceFactory.languageService();
            if (0 < optionItem) {
                el.text = new Strings(languageService.translation('reminder_cta_minute')).injectIntoCurly({reminderValue: optionItem});
            } else {
                el.text = languageService.translation('reminder_off_option');
            }

            return el;
        });

        reminderOptions.forEach(el => {
            DOM.append(ddlReminder[0], el);
        });

        // init selected
        let selectedReminder = this._model.getOptions().reminder;
        if (selectedReminder) {
            ddlReminder[0].selectedIndex = reminderIntervals.findIndex(index => index === selectedReminder.totalMinutes);
        }
        return this;
    }


    /**
     * Subscribe handlers for DOM events
     * @private
     */
    _subscribeDOMEvents() {
        this.onChildElementEvent(REMINDER_SETTINGS_SELECTORS.MORE_INFO_SWITCH, USER_EVENTS.ON_CLICK, () => {
            let reminderText = DOM.$$('.cgp-reminder-text');
            DOM.toggleClass(reminderText[0], 'cgp-info-open');
            let reminderInfo = this.getEl().querySelectorAll(REMINDER_SETTINGS_SELECTORS.REMINDER_INFO)[0];
            let display = window.getComputedStyle(reminderInfo).display;
            let openType = 'block' === display ? 'Open' : 'Close';
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: 'Client_RealityCheck_Set',
                action: 'MoreInfo',
                label: openType
            });
            this._sendElasticData(ELASTIC_ACTION_NAMES.MOREINFO, openType);
        });

        return this;
    }

    _sendElasticData(action, value = null) {
        let eventData = {
            CGPEventCategory: 'Client_RealityCheck_Detail',
            CGPEventAction: action,
            RegulationID: this.serviceFactory.regulationService().getRegulationCode()
        };

        if (action === ELASTIC_ACTION_NAMES.SAVE) {
            eventData.CGPEventValue = value + '';
            eventData.CGPEventValueAsNumber = value;
        } else if (action === ELASTIC_ACTION_NAMES.MOREINFO) {
            eventData.CGPEventValue = value;
        }

        let logger = this.serviceFactory.structuredLoggingService()
            .getLogger(eventData)
            .setTarget('casino-realityCheck');

        logger.info();
    }

    /**
     * Save reminder value in local storage
     *
     *
     * @param {object} event
     * @returns
     * @private
     */
    _onSaveReminder(event) {
        let value = this._getReminderValue(event),
            intervals = this._getIntervals();
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Client_RealityCheck_Set',
            action: 'TimeIntervalDropdown',
            label: value * 60 + ''
        });
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Client_RealityCheck_Set',
            action: 'Save'
        });
        this._sendElasticData(ELASTIC_ACTION_NAMES.SAVE, value);

        if (intervals.find(index => index === value) !== undefined) {
            // check whether value is OFF
            if (value === intervals[0]) {
                // remove reminder from local storage
                this.off();
            } else {
                // update or set new reminder
                if (this._getReminderKey()) {
                    if (Store.set(this._getReminderKey(), TimeSpan.fromMinutes(value).toString())) {
                        this._model.setOptions({reminder: value});
                    }
                }

            }
        }
    }


    /**
     * Wrapper to close component overlay
     * @returns
     * @private
     */
    _onCancelBtnClicked() {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_RealityCheck_Set', action: 'Cancel'});
        this._sendElasticData(ELASTIC_ACTION_NAMES.CANCEL);
    }


    /**
     * Get title language key
     * @returns {string}
     * @private
     */
    _getTitleKey() {
        return 'reminder_title';
    }

    /**
     * Get custom css class for component
     * @returns {*[]}
     * @private
     */
    _getCustomCSSClassList() {
        return super._getCustomCSSClassList().concat(['cgp-options-reminder']);
    }


    /**
     *
     * @returns {*}
     * @private
     */
    _getReminderValue() {
        let reminder = this.getEl().querySelectorAll(REMINDER_SETTINGS_SELECTORS.REMINDER_OPTIONS)[0],
            value = Number(reminder[reminder.selectedIndex].value);

        return value;
    }


    /**
     * Handle overlay close button click
     */
    onCloseBtnClicked() {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Client_RealityCheck_Set',
            action: 'CloseClick'
        });
        this._sendElasticData(ELASTIC_ACTION_NAMES.CLOSE);
    }


    /**
     * Handle after component open action
     * @protected
     */
    onComponentOpened() {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_RealityCheck_Set', action: 'Open'});
    }


    /**
     * Get buttons configuration to MDP
     * @returns {Array}
     * @privatee
     */
    _getButtons() {
        let buttons = [
            {
                name: this.serviceFactory.languageService().translation('reminder_cta_cancel'),
                type: 'secondary',
                isClosable: true,
                callback: this._onCancelBtnClicked.bind(this),
                forceAnalytic: true
            },
            {
                name: this.serviceFactory.languageService().translation('reminder_cta_save'),
                type: 'main',
                isClosable: true,
                callback: (event) => {
                    this._onSaveReminder(event);
                },
                forceAnalytic: true
            }
        ];

        return buttons;
    }


    /**
     * Callback fired when component is completly removed from DOM
     * @protected
     */
    onComponentClosed() {
        super.onComponentClosed();
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_RealityCheck_Set', action: 'Close'});
    }

    /**
     * Send analytics message
     */
    reportAnalytics() {
        let reminderOptions = this.getOptions();
        const reminderIntervalInSeconds = (reminderOptions.reminder && reminderOptions.reminder.totalSeconds) || 0;
        if (reminderIntervalInSeconds !== 0) {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: 'Client_RealityCheck_Set',
                action: 'TimeSetInLogin',
                label: reminderIntervalInSeconds // time in seconds
            });
        }
    }

}


export default ReminderSettingsController;
